import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aab0bff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rework" }
const _hoisted_2 = { class: "rework_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检验申请类型", -1))
const _hoisted_4 = { class: "rework_list_item_right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客返单号", -1))
const _hoisted_6 = { class: "rework_list_item_right" }
const _hoisted_7 = { class: "rework_list_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客返客户", -1))
const _hoisted_9 = { class: "rework_list_item_right" }
const _hoisted_10 = { class: "black" }
const _hoisted_11 = { class: "rework_list_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退回原因", -1))
const _hoisted_13 = { class: "rework_list_item_right" }
const _hoisted_14 = { class: "rework_qd" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rework_qd_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "x" }),
  /*#__PURE__*/_createElementVNode("span", null, "退回工装清单(1)")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rework_qd_item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rework_qd_item_i" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "black" }, "LK0001："),
    /*#__PURE__*/_createElementVNode("span", { class: "black" }, "10件")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "rework_qd_item_i" }, [
    /*#__PURE__*/_createElementVNode("span", null, "物料信息："),
    /*#__PURE__*/_createElementVNode("span", null, "花键2993 | 21E8-002-2993-H1")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "rework_qd_item_i" }, [
    /*#__PURE__*/_createElementVNode("span", null, "批次号："),
    /*#__PURE__*/_createElementVNode("span", null, "PC-20220719-0001")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"22px"} }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rework_footer_submit" }, "提交", -1))

import { ref, reactive } from 'vue'

    // 表单数据
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    let form = reactive({
        type: '',
        typeName: '',
        clientName: '客户',
        single: '',
        singleName: '',
        reason: ''
    })

    // 类型
    const columns = [{ text: '工序返工', id: 1 },{ text: '客退返工', id: 2 },{ text: '客返返修', id: 3 }]

    // 单号
    const columns3 = ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华']

    let show = ref<boolean>(false)

    let openDH = ref<boolean>(false)

    let openCode = ref<boolean>(false)

    // 类型确认
    const onConfirm = (value: any) => {
        form.type = value.id
        form.typeName = value.text
        show.value = false
    };

    const onCancel = () => {
        show.value = false
    }

    const onConfirm3 = (value: any) => {
        form.single = value.id
        form.singleName = value.text
        openDH.value = false
    };

    const onCancel3 = () => {
        openDH.value = false
    }

    const closePopup = (): void => {
        openCode.value = false
    }

    const onDecode = (data: string[]): void => {
        console.log(data)
        openCode.value = false
    }

    const open = (): void => {
        openCode.value = true
    }

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = true : show = true))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).typeName ? 'black' : '')
          }, _toDisplayString(_unref(form).typeName ? _unref(form).typeName : '点击选择'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(openDH) //@ts-ignore
 ? openDH.value = true : openDH = true))
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).singleName ? 'black' : '')
          }, _toDisplayString(_unref(form).singleName ? _unref(form).singleName : '点击选择客返单号'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(form).clientName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).reason) = $event)),
            placeholder: "请输入退回原因"
          }, null, 512), [
            [_vModelText, _unref(form).reason]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode(_component_van_swipe_cell, null, {
        right: _withCtx(() => [
          _createVNode(_component_van_button, {
            style: {"height":"100%"},
            square: "",
            type: "danger",
            text: "删除"
          })
        ]),
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", { class: "rework_footer" }, [
      _createElementVNode("div", {
        class: "rework_footer_add",
        onClick: open
      }, "扫码添加工装"),
      _hoisted_17,
      _hoisted_18
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(openCode),
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择类型",
          columns: columns,
          onConfirm: onConfirm,
          onCancel: onCancel
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(openDH),
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_isRef(openDH) ? (openDH).value = $event : openDH = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择单号",
          columns: columns3,
          onConfirm: onConfirm3,
          onCancel: onCancel3
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})